import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

const deploymentOptions = [
  {
    title: "Preset Cloud",
    description:
      "Fully managed SaaS with HIPAA-compliant infrastructure on AWS. Get started quickly with enterprise security built in.",
    features: [
      "Multi-tenant architecture on AWS",
      "SOC 2, PCI-DSS, and HIPAA compliant",
      "Multiple deployment regions available",
      "Automatic updates and maintenance",
    ],
    recommended: true,
  },
  {
    title: "Managed Private Cloud",
    description:
      "Dedicated deployment in your own AWS or GCP environment. Your data never leaves your VPC while Preset manages everything.",
    features: [
      "Runs in your cloud account",
      "VPC peering and PrivateLink support",
      "Customer-managed encryption keys",
      "Full data residency control",
    ],
    recommended: false,
  },
]

function DeploymentOptionsSection() {
  return (
    <Container section>
      <Heading
        label="Flexible Deployment"
        title="Choose the Right Option for Your Organization"
        subtitle="Whether you prefer fully managed SaaS or dedicated private cloud, Preset offers HIPAA-compliant deployment options to meet your requirements."
        decoration="border"
      />
      <div className="mt-12 grid gap-8 lg:grid-cols-2">
        {deploymentOptions.map((option) => (
          <div
            key={option.title}
            className={`relative rounded-2x border-2 p-8 ${
              option.recommended
                ? "border-lush bg-white"
                : "border-drift-grey bg-white"
            }`}
          >
            {option.recommended && (
              <div className="absolute -top-3 left-6 rounded-full bg-lush px-3 py-1 text-xs font-bold text-white">
                Most Popular
              </div>
            )}
            <h3 className="mb-3 text-2xl font-bold text-black">
              {option.title}
            </h3>
            <p className="mb-6 text-base text-dark-grey">
              {option.description}
            </p>
            <ul className="space-y-3">
              {option.features.map((feature) => (
                <li key={feature} className="flex items-start gap-3">
                  <svg
                    className="mt-0.5 h-5 w-5 flex-shrink-0 text-lush"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-base text-dark-grey">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Container>
  )
}

export default DeploymentOptionsSection
